
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Breadcrumb } from "@components/breadcrumb";
import { Products } from "@components/products";
import { ROLLERS } from "@consts/rrollers";
import type { IProduct } from "@type/products";
import { getAllRollersByParent } from "@utils/get-products";
import parse from "html-react-parser";
import type { GetStaticProps, NextPage } from "next/types";
interface IProductCard {
    product: IProduct;
    products: IProduct[];
}
const TestCenter: NextPage<IProductCard> = ({ product, products }) => (<div className="bg-white">
    <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
      <Breadcrumb />
      {product?.title}
      <hr />
      <div>{parse(product?.content || "")}</div>
      <hr />
      {products && <Products products={products} showId/>}
    </div>
  </div>);
// export const getStaticPaths: GetStaticPaths = async () => {
//   const paths: never[] = [];
//   return {
//     paths,
//     fallback: 'blocking',
//   };
// };
const getStaticProps: GetStaticProps = async (context) => {
    // const slug = context.params?.slug as string;
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    // const PRODUCT_ID = slug?.split('-').pop();
    // console.log('context', context);
    // const { product } = await getRollerById(168);
    const { products } = await getAllRollersByParent(ROLLERS.SCREENS[LOCALE as keyof typeof ROLLERS.SCREENS], LOCALE);
    return {
        props: {
            // product,
            products,
        },
    };
};
export default TestCenter;

    async function __Next_Translate__getStaticProps__1a19cd2c0ff__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/rollers/screens/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2c0ff__ as getStaticProps }
  